<template>
    <div :class="portalContentAndDesignStore.getPageContainerClasses">
        <div>
            <div id="sub-account-login">
                <!-- Sub-account login title -->
                <div class="mb-6">
                    <h2
                        :class="[
                            'text-xl font-semibold text-center',
                            portalContentAndDesignStore.getPageContentTextColorClass
                        ]"
                    >
                        <editable-text-field
                            v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_sub_account_title"
                            text-type="span"
                        />
                    </h2>
                </div>

                <!-- Login form -->
                <sub-account-login-form />

                <honeypot-fields />

                <!-- Turnstile Widget -->
                <div v-if="turnstileEnabled" ref="turnstileContainer" class="my-4"></div>

                <editable-btn
                    :prevent-double-click="5000"
                    size="huge"
                    class="w-full"
                    :type="buttonType"
                    :corners="portalContentAndDesignStore.getPublicPageButtonCorners"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_login"
                    :loading="portalContentAndDesignStore.loggingInProgress"
                    :disabled="portalContentAndDesignStore.loggingInProgress"
                    @click="submitLogin"
                >
                    {{ portalContentAndDesignStore.translationSettings.portal_translation_login_login }}
                </editable-btn>

                <!-- Link back to partner login -->
                <div
                    :class="[
                        'flex space-x-1 pt-6 text-sm justify-center',
                        portalContentAndDesignStore.getPageContentTextColorClass
                    ]"
                >
                    <editable-text-field
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_partner"
                        text-type="span"
                    />
                    <editable-text-field
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_partner_login_here"
                        text-type="a"
                        :href="portalContentAndDesignStore.isPreview ? '#' : portalContentAndDesignStore.getLoginRoute"
                        :class="[
                            'text-opacity-100 hover:underline',
                            portalContentAndDesignStore.getLinkColorClass
                        ]"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, onMounted, nextTick, ref} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";
import SubAccountLoginForm from "./Partial/SubAccountLoginForm.vue";
import EditableBtn from "../../../portal-editable-fields/EditableBtn.vue";
import EditableTextField from "../../../portal-editable-fields/EditableTextField.vue";
import HoneypotFields from "../../HoneypotFields.vue";
import {useSubAccountLogin} from "../../../../../composables/partners/useSubAccountLogin";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const turnstileContainer = ref(null);
const turnstileToken = ref(null);
let turnstileWidgetId = null;

const { submitLogin, turnstileEnabled } = useSubAccountLogin(turnstileToken);

const buttonType = computed(() => {
    return portalContentAndDesignStore.getPageContentButtonColorClass
});

const initTurnstile = () => {
    const settings = portalContentAndDesignStore.turnstileSettings;
    if (!settings?.turnstile_enabled || !turnstileContainer.value) return;

    const renderWidget = () => {
        if (typeof window.turnstile === 'undefined') {
            setTimeout(renderWidget, 100);
            return;
        }
        if (turnstileWidgetId !== null) return;

        turnstileWidgetId = window.turnstile.render(turnstileContainer.value, {
            sitekey: settings.turnstile_site_key,
            callback: (token) => { turnstileToken.value = token; },
            'expired-callback': () => { turnstileToken.value = null; },
            'error-callback': () => { turnstileToken.value = null; },
        });
    };

    renderWidget();
};

onMounted(() => {
    nextTick(() => initTurnstile());
});
</script>

